;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type React from "react";
import {Button, type ButtonProps} from "@/components/ui/button";
import {Link} from "@/i18n/routing";
import type {Case, Insight, Page} from "@/payload-types";
import {cn} from "@/utilities/ui";

export type CMSLinkType = {
	appearance?: "inline" | ButtonProps["variant"];
	children?: React.ReactNode;
	className?: string;
	label?: string | null;
	newTab?: boolean | null;
	reference?: {
		relationTo: "pages" | "cases" | "insights" | string | null;
		value: Page | Case | Insight | string | number;
	} | null;
	size?: ButtonProps["size"] | null;
	type?: "custom" | "reference" | null;
	url?: string | null;
	onClick?: () => void;
};

export const getCMSLinkHref = ({
	type,
	reference,
	url,
}: Pick<CMSLinkType, "type" | "reference" | "url">): string | null => {
	if (
		type === "reference" &&
		reference?.value &&
		typeof reference.value === "object" &&
		"slug" in reference.value &&
		reference.value.slug
	) {
		return `${reference.relationTo !== "pages" ? `/${reference.relationTo}` : ""}/${
			reference.value.slug
		}`;
	}

	return url || null;
};

export const CMSLink: React.FC<CMSLinkType> = (props) => {
	const {
		type,
		appearance = "inline",
		children,
		className,
		label,
		newTab,
		reference,
		size: sizeFromProps,
		url,
		onClick,
	} = props;

	const href = getCMSLinkHref({ type, reference, url });

	if (!href) return null;

	const size = appearance === "inline" ? "clear" : sizeFromProps;
	const newTabProps = newTab
		? { rel: "noopener noreferrer", target: "_blank" }
		: {};

	/* Ensure we don't break any styles set by richText */
	if (appearance === "inline") {
		return (
			<Button
				onClick={onClick}
				asChild
				className={className}
				size={size}
				variant={appearance}
			>
				<Link
					className={cn(className)}
					href={href || url || ""}
					{...newTabProps}
				>
					{label && label}
					{children && children}
				</Link>
			</Button>
		);
	}

	return (
		<Button
			onClick={onClick}
			asChild
			className={className}
			size={size}
			variant={appearance}
		>
			<Link className={cn(className)} href={href || url || ""} {...newTabProps}>
				{label && label}
				{children && children}
			</Link>
		</Button>
	);
};
